import { urlUtil } from '@grafana/data';
import { DefaultTimeRange } from '../interpolation/defaults.js';
import { SkipFormattingValue } from './types.js';

class UrlTimeRangeMacro {
  constructor(name, sceneObject) {
    this.state = { name, type: "url_variable" };
    this._sceneObject = sceneObject;
  }
  getValue() {
    var _a;
    const timeRange = getTimeRange(this._sceneObject);
    const urlState = (_a = timeRange.urlSync) == null ? void 0 : _a.getUrlState();
    return new SkipFormattingValue(urlUtil.toUrlParams(urlState));
  }
  getValueText() {
    return "";
  }
}
function getTimeRange(sceneObject) {
  const { $timeRange } = sceneObject.state;
  if ($timeRange) {
    return $timeRange;
  }
  if (sceneObject.parent) {
    return getTimeRange(sceneObject.parent);
  }
  return DefaultTimeRange;
}

export { UrlTimeRangeMacro };
//# sourceMappingURL=UrlTimeRangeMacro.js.map
